import type { TFunction } from 'i18next';

import {
  AccountBalanceIcon,
  CalendarIcon,
  NotificationsIcon,
  PodcastsIcon
} from '@/assets';
import type { RegionFilterOption } from '@/features/geo-area/components/region/RegionFilterDropdown';
import type { RegionPageTab } from '@/features/geo-area/components/region/regionTypes';
import { RegionTab } from '@/features/geo-area/components/region/regionTypes';

export const EVENTS_RADIUS_OPTIONS_KM = [25, 50, 100] as const;
export const DEFAULT_EVENTS_RADIUS_KM = 25;

type RegionTFunction = TFunction<'geo-area', 'screens.myRegion'>;

export const getRegionTabs = (
  t: RegionTFunction,
  hasNewEmergency: boolean
): RegionPageTab[] => [
  {
    key: RegionTab.MINISTRIES,
    label: t('tabs.ministries'),
    icon: AccountBalanceIcon
  },
  {
    key: RegionTab.REGIONAL_RADIO,
    label: t('tabs.regionalRadio'),
    icon: PodcastsIcon
  },
  {
    key: RegionTab.EMERGENCY,
    label: t('tabs.emergency'),
    icon: NotificationsIcon,
    dot: hasNewEmergency
  },
  { key: RegionTab.EVENTS, label: t('tabs.events'), icon: CalendarIcon }
];

export const getEventsRadiusFilters = (
  t: RegionTFunction
): RegionFilterOption<number>[] =>
  EVENTS_RADIUS_OPTIONS_KM.map((radiusKm) => ({
    value: radiusKm,
    label: t('filters.radiusKm', { radiusKm })
  }));
